import dayjs from "dayjs";
import store from "../../../../stateManagement/store"
import { INVALID, INVALID_ALL_COLUMN_ALL_IN_ILC, INVALID_BATCHCODE_OVERLAPPING, VALID, labelMappings,COUPON_TYPE_OPTIONS_VALUE, INVALID_RANGE_OVERLAPPING } from "../../utils/utils";
import { mustBuyAllminQtyFilled, mustBuyAllminQtyGreaterThanZero, validateMustBuy } from "../DefineCoupon/mustBuy/service";
import { ALLColumsALLVAlidation, getHeadersList } from "../DefineCoupon/productSelection/service";
import { isCouponTimingsSlabValid, validateSingleSabCouponTiming } from "../DefineCoupon/recurrence/RecurrenceService";
import { CouponTimingSlab } from "../../types";
import { checkActiveTime } from "../../services/services";

/**
 * validation of current tab saved data
 */
// export const validateCurrentTab = ()=>{
//     const {currentTab}:{currentTab:string} = store.getState()?.manageCoupons?.configData;

//     switch(currentTab){
//         case '0': return validateCouponTypeOptions();
//         case '1': return validateMarketDetails();
//         case '2': return validateSelectedUsabilityLimits();
//         default : return {status:VALID, data:''};
//     }
// }

export const validateALLTabsData = async()=>{
    const res1 = await validateCouponTypeOptions();
    const res2 = validateMarketDetails();
    const recurrenceValidation = validateRecurrence();
    // const res3 = validateSelectedUsabilityLimits();
    //add recurrnce validation

    return [...res1, ...res2, ...recurrenceValidation];
}


/**
 * checks recurrence validations
 * @returns list of invalid results
 */
export const validateRecurrence = (): { label: string, data: string }[] => {
    const result: any[] = [];
    const {schemeType, usabilityLimits} = store.getState()?.manageCoupons?.data;
    const { dateStartEnd, activePeriodCustomDates, activePeriodDays, activePeriodWeeks, activePeriodMonths, usabilityLimit, usability, orderResetFrequency, nDaysFromActivation, numberOfPurchases, couponLife,skipNthOrder ,couponTimings} = store.getState()?.manageCoupons?.data?.recurrence;

    if (dateStartEnd.startDate === null || !dayjs(dateStartEnd.startDate).isValid()) {
        result.push({ label: 'startDate', data: labelMappings["VALIDATION_START_DATE_INVALID"] });
    }
    if (dateStartEnd.endDate === null || !dayjs(dateStartEnd.endDate).isValid()) {
        result.push({ label: 'endDate', data: labelMappings["VALIDATION_END_DATE_INVALID"] });
    }

    if(checkActiveTime()){
        let response = validateCouponTimings();
        if (response.status !== VALID) result.push({ label: "COUPON_TIMING", data: response.data });
    }


    if (!skipNthOrder && (numberOfPurchases === "" || orderResetFrequency === "" || orderResetFrequency === null)) {
        result.push({label:'define-nth-purchase',data:labelMappings["EMPTY_NTH_PURCHASE_ERROR"]});
    }
    if (!skipNthOrder && (Number(numberOfPurchases) <= 1)) {
        result.push({label:'define-nth-purchase', data:labelMappings["NTH_PURCHASE_GREATER_THAN_1_Alert"]});
    }

    if (result.length > 0) return result;

    if (dateStartEnd.startDate > dateStartEnd.endDate && dateStartEnd.startDate !== null && dateStartEnd.endDate !== null) {
        result.push({ label: 'startDate', data: labelMappings["VALIDATION_START_DATE_LESS_THAN_END_DATE"] });
        result.push({ label: 'endDate', data: labelMappings["VALIDATION_START_DATE_LESS_THAN_END_DATE"] });
    }

    if (dateStartEnd.startDate !== null && dateStartEnd.startDate < dayjs().startOf('day')) {
        result.push({ label: 'startDate', data: "Start Date " + labelMappings["VALIDATION_DATE_GRETAER_THAN_TODAY"] });
    }
    if (dateStartEnd.endDate !== null && dateStartEnd.startDate < dayjs().startOf('day')) {
        result.push({ label: 'endDate', data: "End Date " + labelMappings["VALIDATION_DATE_GRETAER_THAN_TODAY"] });
    }
    if ((orderResetFrequency !== undefined && orderResetFrequency !== null && orderResetFrequency !== "") && (numberOfPurchases !== undefined && numberOfPurchases !== null && numberOfPurchases === "")) {
        result.push({ label: 'Order Reset Frequency', data: labelMappings["RECURRENCE_NTH_ORDER_INVALID"] });
    }
    if ((numberOfPurchases !== undefined && numberOfPurchases !== null && numberOfPurchases !== "") && (orderResetFrequency !== undefined && orderResetFrequency !== null && orderResetFrequency === "")) {
        result.push({ label: 'Number of Purchases', data: labelMappings["RECURRENCE_NTH_ORDER_FREQUENNCY_INVALID"] });
    }
    if ((usabilityLimit !== undefined && usabilityLimit !== null && usabilityLimit !== "") && (usability !== undefined && usability !== null && usability === "")) {
        result.push({ label: 'Usability Limit Period', data: labelMappings["RECURRENCE_USABILITY_INVALID"] });
    }
    if ((usability !== undefined && usability !== null && usability !== "") && (usabilityLimit !== undefined && usabilityLimit !== null && usabilityLimit === "")) {
        result.push({ label: 'Usability Limit', data: labelMappings["RECURRENCE_USABILITY_LIMIT_INVALID"] });
    }
    if ((usability !== undefined && usability !== null && usability !== "") && (usabilityLimit !== undefined && usabilityLimit !== null && usabilityLimit === "0")) {
        result.push({ label: 'Usability Limit', data: labelMappings["RECURRENCE_USABILITY_LIMIT_INVALID_ZERO"] });
    }
    if((couponLife!==undefined && couponLife!==null && couponLife!=="") && (usability !== undefined && usability !== null && usability !== "") && (parseInt(usabilityLimit)>parseInt(couponLife))){
        result.push({ label: 'Usability Limit', data: labelMappings["COUPON_LIFE_CANNOT_BE_LESS_THAN_USAGE_LIMIT"] });
    }

    if ((schemeType.toLowerCase() === "percentage") && (usabilityLimits.percentageMaxAmount === undefined || usabilityLimits.percentageMaxAmount === null || (typeof usabilityLimits.percentageMaxAmount === "string" && usabilityLimits.percentageMaxAmount.trim() === ""))) {
        result.push({ label: 'Max Discount', data: labelMappings["MAX_DISCOUNT_CANNOT_BE_NULL"]});
    }
    return result;
}


export const validateCouponTypeOptions = async (): Promise<{ label: string, data: string }[]> => {
    const result = [];

    let response;
    response = validateCouponTypeOptionField();
    if (response.status !== VALID) result.push({ label: "coupon-type-options", data: response.data });

    response = validateSchemeType();
    if (response.status !== VALID) result.push({ label: "coupon-calculation", data: response.data });

    response = await validateSchemeProductBifurcationsList();
    if (response.status !== VALID) result.push({ label: "product-selection", data: response.data });

    response = await validateSelectedMustBuy();
    if (response.status !== VALID) result.push({ label: "must-buy", data: response.data });

    response = validateSlabInfo();
    if (response.status !== VALID) result.push({ label: "applicable-slab", data: response.data });
    return result;
}

export const validateMarketDetails = ():{label:string,data:string}[] =>{
    const {schemeOutletBifurcationsList , schemeLocationBifurcationsList,skipMarketSelection} = store.getState()?.manageCoupons?.data;
    const {list:inclusionList} = store.getState()?.manageCoupons?.data?.inclusionData;

    const result:{label:string,data:string}[] =[];
    if(!skipMarketSelection && (schemeOutletBifurcationsList.length === 0 && schemeLocationBifurcationsList.length === 0 && inclusionList.length === 0)){
        result.push({label:"market-details",data:labelMappings["MARKET_DETAILS_EMPTY"]});
    }
    
    return result;
}
export const validateSelectedUsabilityLimits = (): { label: string, data: string }[] => {
    const result: any[] = [];

    const {schemeType , usabilityLimits  } = store.getState()?.manageCoupons?.data;
    const {startDate , endDate,percentageMaxAmount } = usabilityLimits;

    if(startDate === null || !dayjs(startDate).isValid()){
        result.push({label:'startDate' , data:labelMappings["VALIDATION_START_DATE_INVALID"]});
    }
    if (endDate === null || !dayjs(endDate).isValid()) {
        result.push({ label: 'endDate', data: labelMappings["VALIDATION_END_DATE_INVALID"] });
    }
    if(schemeType === "percentage" && percentageMaxAmount === ""){
        result.push({label:'PERCENTAGE_MAX_AMOUNT' , data: labelMappings["INVALID_REQUIRED_FIELD"]});
    }

    if (result.length > 0) return result;

    if (startDate > endDate && startDate !== null && endDate !== null) {
        result.push({ label: 'startDate', data: labelMappings["VALIDATION_START_DATE_LESS_THAN_END_DATE"] });
        result.push({ label: 'endDate', data: labelMappings["VALIDATION_START_DATE_LESS_THAN_END_DATE"] });
    }

    if (startDate !== null && startDate < dayjs().startOf('day')) {
        result.push({ label: 'startDate', data: "Start Date " + labelMappings["VALIDATION_DATE_GRETAER_THAN_TODAY"] });
    }
    if (endDate !== null && startDate < dayjs().startOf('day')) {
        result.push({ label: 'endDate', data: "End Date " + labelMappings["VALIDATION_DATE_GRETAER_THAN_TODAY"] });
    }


    

    return result;
}

export const validateCouponTypeOptionField = (): { status: string, data: string } => {
    const { couponTypeOption } = store.getState()?.manageCoupons?.data;
    const response = { status: VALID, data: '' }

    if (couponTypeOption === "" || couponTypeOption === null || couponTypeOption === undefined) {
        response.status = INVALID;
        response.data = labelMappings["VALIDATION_COUPON_TYPE_OPTIONS"];
    }
    return response;
}
export const validateSchemeType = (): { status: string, data: string } => {
    const { schemeType } = store.getState()?.manageCoupons?.data;
    const response = { status: VALID, data: '' }

    if (schemeType === "" || schemeType === null || schemeType === undefined) {
        response.status = INVALID;
        response.data = labelMappings["VALIDATION_CALCULATION_METHOD"];
    }
    return response;
}

export const validateSchemeProductBifurcationsList = async():Promise<{status:string,data:string}>=>{
    const {schemeProductBifurcationsList , couponTypeOption,isOverAndAbove} = store.getState()?.manageCoupons?.data;
    const response= { status:VALID , data:''};

    if(couponTypeOption === COUPON_TYPE_OPTIONS_VALUE.TOTAL_ORDER_VALUE || couponTypeOption === COUPON_TYPE_OPTIONS_VALUE.TOTAL_ORDER_WELCOME ||isOverAndAbove) return response

    if (schemeProductBifurcationsList.length === 0) {
        response.status = INVALID;
        response.data = labelMappings["VALIDATION_PRODUCT_BIFURCATION_LIST_EMPTY"];
    }

    const productHeaderList = await getHeadersList();
    for (let i = 0; i < schemeProductBifurcationsList.length; i++) {
        const currGrp = schemeProductBifurcationsList[i];
        const res = ALLColumsALLVAlidation(currGrp, schemeProductBifurcationsList, productHeaderList, couponTypeOption);
        if (res === INVALID_ALL_COLUMN_ALL_IN_ILC) {
            response.status = INVALID;
            response.data = labelMappings["ALL_SELECTION_INVALID_IN_ILC"];
            break;
        }
    }

    return response;
}


export const validateSelectedMustBuy = async (): Promise<{ status: string, data: string }> => {
    const { active, data: mustBuy } = store.getState()?.manageCoupons?.data?.mustBuy;
    const response = { status: VALID, data: '' };

    if (!active) return response;

    if (mustBuy.length === 0) {
        response.status = INVALID;
        response.data = labelMappings["VALIDATION_MUST_BUY_LIST_EMPTY"];
    }



    const tabsList = await getHeadersList();


    for (let i = 0; i < mustBuy.length; i++) {
        const res = validateMustBuy(mustBuy[i], tabsList);
        if (res !== VALID) {
            response.status = INVALID;
            response.data = res === INVALID_BATCHCODE_OVERLAPPING ? labelMappings["VALIDATION_MUST_BUY_OVERLAPPING"] : labelMappings["VALIDATION_MUST_BUY_OUT_OF_PRODUCTS_SELECTION_RANGE"];
        }
    }


    if (!mustBuyAllminQtyFilled()) {
        response.status = INVALID;
        response.data = labelMappings["VALIDATION_MUST_BUY_MIN_QTY_NOT_FILLED"];
    }


    if (!mustBuyAllminQtyGreaterThanZero()) {
        response.status = INVALID;
        response.data = labelMappings["VALIDATION_MUST_BUY_MIN_QTY_NEGITIVE"];
    }

    return response;
}

export const validateSlabInfo = (): { status: string, data: string } => {
    const { sectionEnabled } = store.getState()?.manageCoupons?.data;
    const response = { status: VALID, data: '' };


    if (!sectionEnabled["applicableSlab"] || isSlabInfoEmpty()) {
        response.status = INVALID;
        response.data = labelMappings["VALIDATION_SLAB_INFO_LIST_EMPTY"];

    }

    return response
}

export const validateCouponTimings = (): { status: string, data: string } => {
    const { couponTimings }: { couponTimings: Array<CouponTimingSlab> } = store.getState().manageCoupons?.data?.recurrence;
    const response = { status: VALID, data: '' };
    for (let timing of couponTimings) {
        const { st, et , isSaved} = timing;

        if ((st === null && et === null) || !isSaved) continue;

        const validationErrors = validateSingleSabCouponTiming({ st, et }, timing);
        const res = isCouponTimingsSlabValid(validationErrors, timing);

        if (res === INVALID) {
            response.status = INVALID;
            response.data = labelMappings["COUPON_TIMINGS_SLAB_VALIDATION_FAILED"];
        }
        else if (res === INVALID_RANGE_OVERLAPPING) {
            response.status = INVALID;
            response.data = labelMappings["COUPON_TIMING_SLAB_RANGE_OVERLAPPING"];
        }
    }
    return response;
}



export const isSlabInfoEmpty = (): boolean => {
    const { data: slabInfo } = store.getState()?.manageCoupons?.data?.slabInfo;
    if (slabInfo.length === 0) return true;

    // atleat a single slab should be in non edit mode
    let allInEditMode = true;
    for (let i = 0; i < slabInfo.length; i++) {
        if (slabInfo[i].isEdit === false) allInEditMode = false;
    }

    return allInEditMode;
}
